// /src/components/SiteFooter.jsx
// Footer principale del sito Sfarinà, riutilizzato anche dalle Landing Pages /lp/*.
// Su LP, i link interni (menu, sedi) puntano alla home (/#menu, /#sedi) tramite la prop `basePath`.
import React from 'react';
import { Instagram, Facebook } from 'lucide-react';
import { useT } from '../i18n/LanguageContext';
import { sendServerSideEvent } from '../lib/tracking';

const trackClick = (label) => () => {
  sendServerSideEvent('ButtonClick', { button_label: label, source: 'footer' });
};

const SiteFooter = ({ basePath = '' }) => {
  const { t } = useT();
  const menuHref = `${basePath}#menu`;
  const sediHref = `${basePath}#sedi`;

  return (
    <footer className="bg-[#0f0f0f] text-[#EDE8E0]/70 py-12 border-t border-white/10" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          <div className="flex flex-col items-center md:items-start">
            <span className="font-['Poppins',_sans-serif] font-bold text-3xl text-white tracking-tight mb-4">SFARINÀ</span>
            <p className="text-sm">{t.footer.tagline}</p>
            <a href="mailto:sfarinapiadina@gmail.com" onClick={trackClick('footer-email')} data-testid="footer-email" className="mt-3 text-sm hover:text-white transition-colors break-all">sfarinapiadina@gmail.com</a>
            <p className="text-xs mt-2 opacity-75" data-testid="footer-vat">{t.footer.vat}</p>
            <div className="flex gap-4 mt-6">
              <a href="https://www.instagram.com/sfarinapiadina/" target="_blank" rel="noopener noreferrer" onClick={trackClick('footer-instagram')} data-testid="footer-instagram" aria-label="Instagram" className="hover:text-white transition-colors"><Instagram size={24} /></a>
              <a href="https://www.facebook.com/sfarinapiadina/" target="_blank" rel="noopener noreferrer" onClick={trackClick('footer-facebook')} data-testid="footer-facebook" aria-label="Facebook" className="hover:text-white transition-colors"><Facebook size={24} /></a>
            </div>
          </div>
          <div className="flex flex-col items-center md:items-start">
            <h4 className="font-['Poppins',_sans-serif] font-bold text-white mb-4 uppercase tracking-wider text-sm">{t.footer.nav_title}</h4>
            <ul className="space-y-3 text-sm">
              <li><a href={menuHref} onClick={trackClick('footer-menu')} className="hover:text-white transition-colors">{t.nav.menu}</a></li>
              <li><a href={sediHref} onClick={trackClick('footer-sedi')} className="hover:text-white transition-colors">{t.nav.sedi}</a></li>
            </ul>
          </div>
          <div className="flex flex-col items-center md:items-start">
            <h4 className="font-['Poppins',_sans-serif] font-bold text-white mb-4 uppercase tracking-wider text-sm">{t.footer.info_title}</h4>
            <ul className="space-y-3 text-sm">
              <li><a href="#" onClick={trackClick('footer-privacy')} className="hover:text-white transition-colors">{t.footer.privacy}</a></li>
              <li><a href="#" onClick={trackClick('footer-cookie')} className="hover:text-white transition-colors">{t.footer.cookie}</a></li>
            </ul>
          </div>
        </div>
        <div className="text-center text-xs pt-8 border-t border-white/10">{t.footer.copyright_pre} {new Date().getFullYear()} {t.footer.copyright_post}</div>
      </div>
    </footer>
  );
};

export default SiteFooter;
